import {
    ShoppingBag,
    IndianRupee,
    Star,
    MapPin,
} from "lucide-react";

import "./CustomerStatsCard.css";

function CustomerStatsCard({ statistics }) {

    if (!statistics) {

        return null;

    }

    const {

        totalOrders = 0,
        totalSpent = 0,
        totalReviews = 0,
        savedAddresses = 0,

    } = statistics;

    const stats = [

        {
            icon: <ShoppingBag size={22} />,
            label: "Total Orders",
            value: totalOrders,
        },

        {
            icon: <IndianRupee size={22} />,
            label: "Total Spent",
            value: `₹${Number(totalSpent).toLocaleString("en-IN")}`,
        },

        {
            icon: <Star size={22} />,
            label: "Reviews",
            value: totalReviews,
        },

        {
            icon: <MapPin size={22} />,
            label: "Saved Addresses",
            value: savedAddresses,
        },

    ];

    return (

        <div className="customer-stats-card">

            <h2 className="customer-card-title">

                Customer Statistics

            </h2>

            <div className="customer-stats-grid">

                {stats.map((item, index) => (

                    <div
                        key={index}
                        className="customer-stat-box"
                    >

                        <div className="customer-stat-icon">

                            {item.icon}

                        </div>

                        <h3>

                            {item.value}

                        </h3>

                        <p>

                            {item.label}

                        </p>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default CustomerStatsCard;